<template>

	<div>
		<search-control :facets="facets" :pagination="pagination" :sorting="sorting" />
		<product-list :results="results" :pagination="pagination" :merchandising="merchandising" />
		<pagination :pagination="pagination" />
	</div>

</template>

<script>

	import Pagination from './Pagination';
	import ProductList from './ProductList';
	import SearchControl from './SearchControl';

	export default {
		data() {
			return {
				showSort: false
			}
		},
		props: {
			facets: {
				default() {
					return {};
				}
			},
			filterSummary: {
				default() {
					return {};
				}
			},
			merchandising: {
				default() {
					return {};
				}
			},
			pagination: {
				default() {
					return {};
				}
			},
			results: {
				default() {
					return {};
				}
			},
			sorting: {
				default() {
					return {};
				}
			}
		},
		components: {
			'pagination': Pagination,
			'product-list': ProductList,
			'search-control': SearchControl
		}
	}

</script>
